<template>
<div>
  <ed-form :data="formData" :response="response" :config="config" :itens="formDataItems">
    <div slot="form-footer">
      <div class="col-md-12 btn-login">
        <ed-button icon="fa fa-floppy-o" type="success" @click="salvar" :loading="config.loading.save" value="Salvar" />
      </div>
    </div>
  </ed-form>
</div>
</template>

<script>
import Rest from "common/rest";
import EdForm from 'common/form'
import EdButton from 'common/button'
import ItemsFormEditar from './_form/funcionario-editar'

export default {
  components: {
    EdForm,
    EdButton
  },
  mixins: [Rest],
  watch: {
    'formData.id_fdt'() {
      //this.formData.id_funcao = null;
      //this.getFuncao();
    },
    'formData.id_funcao'() {
      this.formData.id_ghe = null;
      this.getGHE();
    }
  },
  data() {
    return {
      loadingContent: false,
      loadingSave: false,
      response: {},
      formDataItems: [],
      config: {
        estado: true,
        click: {
          id_fdt: this.getFDT,
          id_ghe: this.getGHE,
          id_funcao: this.getFuncao
        },
        list: {
          id_fdt: [],
          id_ghe: [],
          id_funcao: []
        },
        loading: {
          id_fdt: false,
          id_ghe: false,
          id_funcao: false,
          save: false,
        },
        tipo: [59],
      },
      formData: {
        id: 0,
        id_estado: null,
        id_cidade: null,
        id_funcao: null,
        id_fdt: null,
        id_ghe: null,
        nome: null,
        cpf: null,
        rg: null,
        cep: null,
        end: null,
        num: null,
        bairro: null,
        comp: null,
        ct_num: null,
        ct_serie: null,
        ct_uf: null,
        tel_res: null,
        tel_cel: null,
        dt_nas: null,
        sexo: null,
        email: null,
        mat: null,
        pis: null,
        status: null,
        pcd:0,
        obs: null,
        created_user: 0,
        created_at: null,
        updated_at: null,
      },
    };
  },

  created() {},

  mounted() {
    this.formDataItems = ItemsFormEditar;
    this.getFDT();
  },

  methods: {

    getFuncao(_search) {

      this.config.loading.id_funcao = true;
      this.config.list.id_funcao = [];

      var filter = {
        'id_fdt': this.formData.id_fdt
      };

      this.get('funcao', {
        search: _search,
        filter: filter,
        pagination: 100
      }).then((result) => {
        result = result[0];

        this.config.loading.id_funcao = false;

        if (result.status == 200) {
          this.config.list.id_funcao = result.data.data;
        }
      });
    },

    getFDT() {

      this.config.loading.id_fdt = true;
      this.config.list.id_fdt = [];

      let filter = {
        ativo: 1,
      };

      this.get('pcmso/fdt', {
        filter: filter
      }).then((result) => {
        result = result[0];

        this.config.loading.id_fdt = false;

        if (result.status == 200) {
          this.config.list.id_fdt = result.data.data;
          //this.getFuncao();
        }
      });
    },

    getGHE() {

      this.config.loading.id_ghe = true;
      this.config.list.id_ghe = [];
      this.formData.id_ghe = null;

      var filter = {
        id_fdt: this.formData.id_fdt,
        id_funcao: this.formData.id_funcao
      };

      this.get('pcmso/ghe', {
        filter: filter,
        pagination: 100
      }).then((result) => {
        result = result[0];

        this.config.loading.id_ghe = false;

        if (result.status == 200) {
          this.config.list.id_ghe = result.data;

          // if (this.config.list.id_ghe.length > 0) {
          //   var revisao = this.config.list.id_ghe[this.config.list.id_ghe.length - 1];
          //   if (revisao && revisao.options.length > 0) {
          //     this.formData.id_ghe = revisao.options[revisao.options.length - 1].id;
          //   }
          // }
        }
      });
    },

    salvar() {
      this.config.loading.save = true;
      this.response = {};

      this.post('funcionario/0/editar', this.formData).then((result) => {
        result = result[0];
        console.log(result);

        this.config.loading.save = false;
        this.response = result;

        if (result.status == 200)
        {
          if(typeof result.data.cadastrado !== 'undefined' && result.data.cadastrado !== null)
          {
            this.$confirm('CPF já cadastrado, deseja transferir o Funcionário de empresa?', 'Atenção', { type: 'warning'}).then(() => 
            {
              this.formData.created_user = 1;
              console.log(this.formData);
              
              this.salvar();

            }).catch(()=>{
              this.toRoute({
                name: 'empresa.funcionario',
              });
            });
          }
          else
          {
            this.edMsg('Dados atualizados com sucesso');
            this.toRoute({
              name: 'empresa.funcionario.edt',
              params: {
                id: result.data.id
              }
            });
          }

        }
      });

    }
  }
};
</script>



// WEBPACK FOOTER //
// cadastrar.vue?fd8f488a